export type Status = 'good' | 'warn' | 'alert' | 'info';

export function getStatus(
  value: number,
  lo: number,
  hi: number,
  warnLo?: number,
  warnHi?: number
): Status {
  if (warnLo !== undefined && value < warnLo) return 'alert';
  if (warnHi !== undefined && value > warnHi) return 'alert';
  if (value < lo) return 'warn';
  if (value > hi) return 'warn';
  return 'good';
}

export function getStatusColor(status: Status): string {
  const colors: Record<Status, string> = {
    good: 'var(--green)',
    warn: 'var(--amber)',
    alert: 'var(--red)',
    info: '#2563eb',
  };
  return colors[status];
}

export function getStatusBgColor(status: Status): string {
  const colors: Record<Status, string> = {
    good: 'var(--green-bg)',
    warn: 'var(--amber-bg)',
    alert: 'var(--red-bg)',
    info: '#eff6ff',
  };
  return colors[status];
}
